module.exports = __webpack_public_path__ + "static/accident_illness_policy.e6b71524.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/policies/accident_illness_policy.pdf
// module id = 323
// module chunks = 177890977751730